import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

import { useAiAssistant } from './AiAssistantContext';
import { AiAssistantPanel } from './AiAssistantPanel';
import { Launcher } from './styles';
import type { EstimateSnapshot } from './types';

// Single mount point for the assistant: a floating launcher plus the slide-in
// drawer. The drawer (and therefore the chat session) is created lazily on the
// first open and then kept mounted so history survives navigation/collapse.
export function AiAssistantWidget() {
  const { authState } = useOktaAuth();
  const isAuthenticated = authState?.isAuthenticated === true;
  const { isOpen, open, close, estimateSnapshot } = useAiAssistant();
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
    }
  }, [isOpen]);

  // Keep a ref so useChat gets a stable getter that always reads the latest snapshot.
  const snapshotRef = useRef<EstimateSnapshot>(estimateSnapshot);
  snapshotRef.current = estimateSnapshot;
  const getEstimateSnapshot = useCallback(() => snapshotRef.current, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {!isOpen && (
        <Launcher aria-label="Open AI assistant" onClick={open} type="button">
          <img alt="" height={30} src="/images/icon-ai-assistant.svg" width={30} />
        </Launcher>
      )}
      {hasOpened && (
        <AiAssistantPanel getEstimateSnapshot={getEstimateSnapshot} onClose={close} open={isOpen} />
      )}
    </>
  );
}
